export default "__VITE_ASSET__DVy6zw_v__"